import styled, { css } from "styled-components";
import { fontSizes } from "healthex-common/sizes";
import { FormLabel } from "./GlobalAdminUserFormBase.styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { HXTextField } from "../base.styles";
export const LoginExplanation = styled.div `
    font-size: ${fontSizes.SMALL};
    margin-bottom: 16px;
`;
export const PasswordInfoIcon = styled(InfoOutlinedIcon) `
    vertical-align: middle;
    margin-left: 8px;
    font-size: 24px;
`;
export const PasswordRequirementsTooltip = styled.div `
    & ul {
        padding-left: 24px;
    }
`;
export const FormItem = styled.div `
    display: flex;
    flex-direction: row;
    padding: 5px 0px;
    font-size: ${fontSizes.SMALL};
    height: 35px;

    & ${HXTextField} {
        width: 560px;
    }
`;
export const SSOConfig = styled.div `
    margin-left: 24px;
`;
export const SSOConfigTitle = styled.div `
    font-weight: bold;
    margin-bottom: 8px;
`;
export const SSOConfigExplantion = styled.div `
    font-size: ${fontSizes.SMALL};
    margin-bottom: 8px;
`;
export const IDPFieldsTitle = styled.div `
    font-size: ${fontSizes.SMALL};
    font-weight: bold;
    margin-bottom: 8px;
    margin-top: 24px;
`;
export const IDPFieldsExplanation = styled.div `
    font-size: ${fontSizes.SMALL};
    margin-bottom: 8px;
`;
export const SSORequirement = styled.span `
    font-style: italic;
`;
export const GlobalAdminHealthcareOrganizationLoginSettingsViewParent = styled.div `
    & ${FormItem} {
        ${(props) => props.editing &&
    css `
                flex-direction: column;
                align-items: left;
                height: auto;
            `}
    }

    & ${FormLabel} {
        font-weight: normal;

        ${(props) => props.editing &&
    css `
                font-weight: bold;
            `}
    }
`;
